import { Badge, Box, Group, Stack, Text } from '@mantine/core';

const NumberCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                {rowData.simcard ? (
                    <>
                        <Text>{rowData.simcard?.number || '+19165556666'}</Text>
                        <Group gap={'xs'}>
                            <Text>
                                {rowData.simcard?.carrier || 'USCellular'}
                            </Text>
                            {rowData.simcard?.carrier ===
                            rowData.simcard?.upstreamCarrier ? (
                                <Badge size={'xs'}>
                                    {rowData.simcard?.carrier || 'VZW'}
                                </Badge>
                            ) : null}
                        </Group>
                    </>
                ) : (
                    <>---</>
                )}
            </Stack>
        </Box>
    );
};

const NumberColumn = () => ({
    accessorKey: 'numberFormatted',
    header: 'Number / Carrier',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <NumberCell cell={cell} />,
});
export default NumberColumn;
